import React, {Component} from 'react';
import {$} from '../ext-refs';
import {FieldWrapper, StateWrapper} from "../form-validator";
import PropTypes from 'prop-types';
import classNames from "classnames";

/**
 * React wrapper for time field
 * @see https://mdbootstrap.com/javascript/time-picker/
 */
class TimeField extends Component {
    constructor(props) {
        super(props);
        this.afterDone = this.afterDone.bind(this);
    }

    afterDone() {
        let {name, setValue, postProcess} = this.props,
            $s = $(this.node);
        setValue(name, $s[0].value, postProcess);
    }

    componentDidMount() {
        const $s = $(this.node);
        $s.pickatime({
            twelvehour: true,
            autoclose: false,
            afterDone: this.afterDone
        });
    }

    render() {
        const {
                name, placeholder, description, className, labelClass,
                // extract validations so it does not go into rest
                validations,
                // These values are injected by StateWrapper
                value, setValue, postProcess, onBlur, validationState,
                ...rest
            } = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);
        return (
            <div className={className || "md-form form-group"}>
                <input
                    name={name}
                    type="text"
                    className={classNames("form-control", "timepicker", {'is-invalid': hasError})}
                    id={name}
                    placeholder={placeholder}
                    onBlur={onBlur}
                    ref={node => {
                        this.node = node
                    }}
                    {...rest}
                />
                {description &&
                    (<label htmlFor={name} className={classNames("active", labelClass)}>
                        {typeof description === 'function' ? description() : description}
                    </label>)
                }
                <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                     aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                    {
                        hasError && messages.map(
                            item => (
                                <div key={item}>
                                    {item}
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

TimeField.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func
    ]),
    placeholder: PropTypes.string,
    value: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    postProcess: PropTypes.func
};

export default FieldWrapper(TimeField);